import { render, staticRenderFns } from "./selectionCriteria.vue?vue&type=template&id=bd78673e&scoped=true&"
import script from "./selectionCriteria.vue?vue&type=script&lang=js&"
export * from "./selectionCriteria.vue?vue&type=script&lang=js&"
import style0 from "./selectionCriteria.vue?vue&type=style&index=0&id=bd78673e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd78673e",
  null
  
)

export default component.exports